<template>
    <div>
        <tabs
            v-if="languagesTabs"
            :active-key="selectedLocale"
            :errors="errors"
            :items="languagesTabs"
            class="mb-16"
            @set-active="selectLanguage($event)"
            scroll
        />


        <slot :languages="languages" :selectedLanguage="selectedLocale">
        </slot>
    </div>
</template>

<script>
import Tabs from '../navigation/Tabs.vue';
import {mapStores} from "pinia";
import {useMainStore} from "../../state/store";

export default {
    components: {
        'tabs': Tabs,
    },
    props: {
        errors: Array,
    },
    computed: {
        ...mapStores(useMainStore),
        selectedLocale() {
            return this.mainStore.selectedLocale;
        },
        currentCompany() {
            return this.mainStore.currentCompany;
        },
        languages() {
            return this.currentCompany.jobsite.active_languages;
        },
        languagesTabs() {
            if (this.currentCompany.jobsite.active_languages.length === 1) {
                return;
            }

            let languages = {};

            this.currentCompany.jobsite.active_languages.forEach((field, index) => {
                languages[field] = {
                    title: this.$t('languages.' + field + '.title'),
                };
            });

            return languages;
        },
    },
    methods: {
        selectLanguage(language) {
            this.mainStore.setSelectedLocale(language);
        },
    },
    mounted() {
        if (!this.languagesTabs) {
            this.selectLanguage(this.languages[0]);
        }
    }
};
</script>
